<template>
  <div class="tag-promote rounded-circle d-flex flex-column align-items-center justify-content-center">
    <div>優惠價</div>
  </div>
</template>

<script>
export default {
  name: 'TagPromote'
}
</script>

<style scoped>
.tag-promote {
  width: 48px;
  height: 48px;
  background-color: var(--loft-color);
  color: white;
  font-size: 14px;
  font-family: 'Noto Serif TC', serif;
  font-weight: 700;
  line-height: 1;
}
</style>
